export function key(){
    return Math.floor(Math.random() * 1000000);
}